/* eslint-disable no-underscore-dangle */
import PropTypes from "prop-types";
import React from "react";
import { Provider } from "react-redux";
import { Router } from "react-router";
import Immutable from "immutable";
import { StyleRoot } from "radium"; // @NOTE: This can be removed when we remove radium'
import { ErrorBoundary } from "react-error-boundary";
import { captureException } from "utils/errors";
import { GlobalError } from "components/Global/ErrorViews";
import { PostHogProvider } from "posthog-js/react";

const POSTHOG_OPTIONS = {
  api_host: window.__POSTHOG_HOST__
};

// @NOTE: This is a wrapper for the PostHogProvider that is used to prevent the
// PostHogProvider from being rendered in lower environments
const PostHogWrapper = ({ children }) =>
  !window.__ENV__.includes("production") ? (
    children
  ) : (
    <PostHogProvider
      apiKey={window.__POSTHOG_API_KEY__}
      options={POSTHOG_OPTIONS}
    >
      {children}
    </PostHogProvider>
  );

class Root extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  };

  componentDidMount() {
    // make Immutable globally available for use with react-data-grid
    window.Immutable = Immutable;
  }

  render() {
    return (
      <StyleRoot style={{ height: "100%" }}>
        <Provider store={this.props.store}>
          <ErrorBoundary
            FallbackComponent={GlobalError}
            onError={captureException}
          >
            <PostHogWrapper>
              <Router history={this.props.history}>{this.props.routes}</Router>
            </PostHogWrapper>
          </ErrorBoundary>
        </Provider>
      </StyleRoot>
    );
  }
}
export default Root;
